// ============================================================
// Average Basketball Players — shared site behavior
// Loaded on every page. Depends on window.ABP_CONFIG (config.js).
// ============================================================
(function () {
  "use strict";
  var CFG = window.ABP_CONFIG || {};

  /* ---------------- Theme (dark mode) ----------------
   * Saved in browser storage when available. In sandboxed previews where
   * storage is blocked, the choice is carried page-to-page with ?theme=
   * on internal links so it never resets while clicking around. */
  function readThemeParam() {
    try {
      var t = new URLSearchParams(window.location.search).get("theme");
      return t === "dark" || t === "light" ? t : null;
    } catch (e) { return null; }
  }
  function syncThemeLinks(theme) {
    if (window.ABP_STORE && window.ABP_STORE.persistent) return;
    document.querySelectorAll("a[href]").forEach(function (a) {
      var href = a.getAttribute("href");
      if (!href || /^(https?:|mailto:|tel:|#|javascript:)/i.test(href)) return;
      if (!/\.html(\?|#|$)/.test(href)) return;
      try {
        var url = new URL(href, window.location.href);
        url.searchParams.set("theme", theme);
        a.setAttribute("href", url.pathname.split("/").pop() + url.search + url.hash);
      } catch (e) {}
    });
  }
  function initTheme() {
    var root = document.documentElement;
    var stored = null;
    try { stored = window.ABP_STORE.get("abp-theme"); } catch (e) {}
    var theme = readThemeParam() || stored || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    root.setAttribute("data-theme", theme);
    try { window.ABP_STORE.set("abp-theme", theme); } catch (e) {}
    syncThemeLinks(theme);

    var toggles = document.querySelectorAll(".theme-toggle");
    toggles.forEach(function (btn) {
      btn.setAttribute("aria-pressed", theme === "dark" ? "true" : "false");
      btn.addEventListener("click", function () {
        var next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
        root.setAttribute("data-theme", next);
        try { window.ABP_STORE.set("abp-theme", next); } catch (e) {}
        syncThemeLinks(next);
        toggles.forEach(function (b) { b.setAttribute("aria-pressed", next === "dark" ? "true" : "false"); });
      });
    });
  }

  /* ---------------- Mobile menu ---------------- */
  function initMenu() {
    var btn = document.querySelector(".menu-button");
    var nav = document.getElementById("site-nav");
    if (!btn || !nav) return;
    btn.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        nav.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* ---------------- Sticky header shadow ---------------- */
  function initHeaderScroll() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    function onScroll() {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------------- Scroll progress bar ---------------- */
  function initScrollProgress() {
    var bar = document.querySelector(".scroll-progress");
    if (!bar) return;
    function update() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - doc.clientHeight;
      var pct = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
      bar.style.width = pct + "%";
    }
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
  }

  /* ---------------- Back to top ---------------- */
  function initBackToTop() {
    var btn = document.querySelector(".back-to-top");
    if (!btn) return;
    function onScroll() {
      btn.classList.toggle("is-visible", window.scrollY > 480);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* ---------------- Floating contact ---------------- */
  function initFloatingContact() {
    var widget = document.querySelector(".floating-contact");
    if (!widget) return;
    var toggle = widget.querySelector(".floating-contact-toggle");
    toggle.addEventListener("click", function () {
      var open = widget.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function (e) {
      if (!widget.contains(e.target)) widget.classList.remove("is-open");
    });
  }

  /* ---------------- Lazy "loading" fade for images ---------------- */
  function initImageLoad() {
    document.querySelectorAll("img[data-fade]").forEach(function (img) {
      if (img.complete && img.naturalWidth) {
        img.classList.add("is-loaded");
      } else {
        img.addEventListener("load", function () { img.classList.add("is-loaded"); });
      }
    });
  }

  /* ---------------- Expandable FAQ ---------------- */
  function initFaq() {
    document.querySelectorAll(".faq-item").forEach(function (item) {
      var q = item.querySelector(".faq-question");
      var a = item.querySelector(".faq-answer");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var expanded = item.getAttribute("aria-expanded") === "true";
        item.setAttribute("aria-expanded", expanded ? "false" : "true");
        q.setAttribute("aria-expanded", expanded ? "false" : "true");
        a.style.maxHeight = expanded ? "0px" : a.scrollHeight + "px";
      });
    });
  }

  /* ---------------- Password visibility toggle (partner login-style fields, if any) ---------------- */
  function initPasswordToggles() {
    document.querySelectorAll(".pw-toggle").forEach(function (btn) {
      var input = document.getElementById(btn.getAttribute("data-target"));
      if (!input) return;
      btn.addEventListener("click", function () {
        var isPw = input.type === "password";
        input.type = isPw ? "text" : "password";
        btn.textContent = isPw ? "Hide" : "Show";
        btn.setAttribute("aria-pressed", isPw ? "true" : "false");
      });
    });
  }

  /* ---------------- Copy button ---------------- */
  function initCopyButtons() {
    document.querySelectorAll(".copy-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var targetSel = btn.getAttribute("data-copy-target");
        var text = targetSel ? (document.querySelector(targetSel) || {}).textContent : btn.getAttribute("data-copy-text");
        if (!text) return;
        var done = function () {
          var original = btn.textContent;
          btn.textContent = "Copied";
          btn.classList.add("is-copied");
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove("is-copied");
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(done);
        } else {
          done();
        }
      });
    });
  }

  /* ---------------- Modal (confirmation) ---------------- */
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add("is-open");
    var closeBtn = modal.querySelector(".modal-close");
    if (closeBtn) closeBtn.focus();
  }
  function closeModal(modal) {
    modal.classList.remove("is-open");
  }
  function initModals() {
    document.querySelectorAll("[data-open-modal]").forEach(function (trigger) {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        openModal(trigger.getAttribute("data-open-modal"));
      });
    });
    document.querySelectorAll(".modal-overlay").forEach(function (modal) {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) closeModal(modal);
      });
      modal.querySelectorAll(".modal-close, [data-close-modal]").forEach(function (btn) {
        btn.addEventListener("click", function () { closeModal(modal); });
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        document.querySelectorAll(".modal-overlay.is-open").forEach(closeModal);
      }
    });
  }
  window.ABP_openModal = openModal;

  /* ---------------- UTM tagging for outbound / social links ---------------- */
  function initUtmTracking() {
    var src = CFG.utmSource || "abp_site";
    var med = CFG.utmMedium || "internal";
    document.querySelectorAll("a[data-utm-campaign]").forEach(function (a) {
      try {
        var url = new URL(a.href, window.location.href);
        url.searchParams.set("utm_source", src);
        url.searchParams.set("utm_medium", med);
        url.searchParams.set("utm_campaign", a.getAttribute("data-utm-campaign"));
        a.href = url.toString();
      } catch (e) {}
    });
  }

  /* ---------------- Products + buy buttons — Shopify swap point ---------------- */
  function money(n) {
    var v = Number(n);
    return "$" + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function productUrl(p, qty) {
    if (!CFG.shopifyDomain || !p || !p.shopifyVariantId) return null;
    var base = "https://" + String(CFG.shopifyDomain).replace(/^https?:\/\//, "").replace(/\/$/, "");
    if (CFG.checkoutMode === "cart") {
      return base + "/cart/add?id=" + encodeURIComponent(p.shopifyVariantId) + "&quantity=" + qty;
    }
    return base + "/cart/" + encodeURIComponent(p.shopifyVariantId) + ":" + qty;
  }
  function renderProducts() {
    var products = CFG.products || {};
    document.querySelectorAll("[data-product]").forEach(function (root) {
      var p = products[root.getAttribute("data-product")];
      if (!p) return;
      root.querySelectorAll("[data-field]").forEach(function (el) {
        var f = el.getAttribute("data-field");
        if (f === "price") el.textContent = money(p.price);
        else if (f === "compareAt") { el.textContent = p.compareAt ? money(p.compareAt) : ""; el.hidden = !p.compareAt; }
        else if (f === "image") { el.src = p.image; el.alt = p.imageAlt || p.name; }
        else if (f === "gallery") {
          var main = el.closest("[data-product]").querySelector('[data-field="image"]');
          var pics = p.gallery || [];
          el.hidden = pics.length < 2;
          el.innerHTML = "";
          pics.forEach(function (g, i) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = "hat-thumb" + (i === 0 ? " is-active" : "");
            b.setAttribute("aria-label", "Show " + g.alt.toLowerCase());
            b.setAttribute("aria-pressed", i === 0 ? "true" : "false");
            b.innerHTML = '<img src="' + g.src + '" alt="" loading="lazy">';
            b.addEventListener("click", function () {
              if (main) { main.src = g.src; main.alt = (p.name + ", " + g.alt).toLowerCase().replace(/^./, function (c) { return c.toUpperCase(); }); }
              el.querySelectorAll(".hat-thumb").forEach(function (t) { t.classList.remove("is-active"); t.setAttribute("aria-pressed", "false"); });
              b.classList.add("is-active"); b.setAttribute("aria-pressed", "true");
            });
            el.appendChild(b);
          });
        }
        else if (p[f] != null) el.textContent = p[f];
      });
    });
  }
  function initQty() {
    document.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      wrap.querySelectorAll("button[data-step]").forEach(function (b) {
        b.addEventListener("click", function () {
          var v = Math.min(10, Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute("data-step"))));
          input.value = v;
        });
      });
    });
  }
  function initBuyButtons() {
    renderProducts();
    initQty();
    document.querySelectorAll("[data-buy-product]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var key = btn.getAttribute("data-buy-product");
        var p = (CFG.products || {})[key];
        var card = btn.closest("[data-product]");
        var qtyInput = card && card.querySelector("[data-qty] input");
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var url = productUrl(p, qty) || (!p && CFG.shopifyCheckoutUrl);
        if (url) { window.location.href = url; return; }
        openModal("modal-not-live");
      });
    });
  }

  /* ---------------- Generic form handling: validation + success/error state ---------------- */
  function showFieldError(field, message) {
    field.classList.add("has-error");
    var msg = field.querySelector(".form-error-msg");
    if (msg) msg.textContent = message;
  }
  function clearFieldError(field) {
    field.classList.remove("has-error");
  }
  function validateForm(form) {
    var valid = true;
    form.querySelectorAll(".form-field").forEach(function (field) {
      var input = field.querySelector("input, textarea, select");
      if (!input) return;
      clearFieldError(field);
      if (input.hasAttribute("required") && !input.value.trim()) {
        showFieldError(field, "This field is required.");
        valid = false;
        return;
      }
      if (input.type === "email" && input.value.trim()) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!re.test(input.value.trim())) {
          showFieldError(field, "Enter a valid email address.");
          valid = false;
        }
      }
    });
    return valid;
  }
  function formToText(form) {
    var lines = [];
    form.querySelectorAll("input, select, textarea").forEach(function (el) {
      if (!el.name) return;
      var label = form.querySelector('label[for="' + el.id + '"]');
      var val = el.tagName === "SELECT" ? el.options[el.selectedIndex].text : el.value.trim();
      lines.push((label ? label.textContent.trim() : el.name) + ": " + val);
    });
    return lines.join("\n");
  }
  function initForms() {
    // Shopify-native forms (contact + newsletter): validate, then let Shopify submit.
    document.querySelectorAll('form[id^="abp-native"]').forEach(function (form) {
      var shell = form.closest(".form-shell");
      if (form.querySelector("[data-form-posted]") && shell) {
        shell.classList.add("is-submitted");
        var ok = shell.querySelector(".form-success");
        if (ok) ok.classList.add("is-visible");
      }
      form.addEventListener("submit", function (e) {
        if (!validateForm(form)) { e.preventDefault(); return; }
        var vote = form.querySelector("[data-vote]");
        var tags = form.querySelector('[name="contact[tags]"]');
        if (vote && tags) tags.value = "newsletter, next-drop-vote: " + vote.options[vote.selectedIndex].text;
        var btn = form.querySelector("button[type=submit]");
        if (btn) btn.classList.add("is-loading");
      });
    });
    document.querySelectorAll("form[data-demo-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!validateForm(form)) return;

        var submitBtn = form.querySelector("button[type=submit]");
        var endpointKey = form.getAttribute("data-endpoint-key");
        var endpoint = endpointKey ? CFG[endpointKey] : null;
        var shell = form.closest(".form-shell");

        function done(ok, mailFallback) {
          if (submitBtn) { submitBtn.classList.remove("is-loading"); submitBtn.disabled = false; }
          if (!ok) {
            var err = shell && shell.querySelector(".form-send-error");
            if (err) err.hidden = false;
            return;
          }
          if (shell) shell.classList.add("is-submitted");
          var success = shell ? shell.querySelector(mailFallback ? ".form-success-mail" : ".form-success") : null;
          if (!success && shell) success = shell.querySelector(".form-success");
          if (success) success.classList.add("is-visible");
          var modalId = !mailFallback && form.getAttribute("data-success-modal");
          if (modalId) openModal(modalId);
          form.reset();
        }

        if (submitBtn) { submitBtn.classList.add("is-loading"); submitBtn.disabled = true; }

        if (endpoint) {
          // Works with Formspree, Getform, Klaviyo forms, etc.
          fetch(endpoint, { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
            .then(function (r) { done(r.ok, false); })
            .catch(function () { done(false, false); });
          return;
        }

        // No endpoint yet: open the visitor's email app, addressed to Joey.
        var subject = form.getAttribute("data-mail-subject") || "Message from averagebasketballplayers.com";
        var to = CFG.contactEmail || "";
        window.location.href = "mailto:" + to + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(formToText(form));
        setTimeout(function () { done(true, true); }, 400);
      });
    });
  }

  /* ---------------- Site search ---------------- */
  var SEARCH_INDEX = [
    { title: "The Premium Snapback", url: "/?view=abp-shop#premium", section: "Shop" },
    { title: "The Standard Snapback", url: "/?view=abp-shop#classic", section: "Shop" },
    { title: "Privacy policy", url: "/?view=abp-privacy", section: "Legal" },
    { title: "Shop all hats", url: "/?view=abp-shop", section: "Shop" },
    { title: "Our story", url: "/#story", section: "Home" },
    { title: "Community & voting", url: "/#community", section: "Home" },
    { title: "Join the roster (email list)", url: "/?view=abp-join", section: "Join" },
    { title: "Partner with Average Basketball Players", url: "/?view=abp-partner", section: "Partner" },
    { title: "Sponsorship tiers", url: "/?view=abp-partner#tiers", section: "Partner" },
    { title: "Partner FAQ", url: "/?view=abp-partner#faq", section: "Partner" },
    { title: "Start a partnership inquiry", url: "/?view=abp-partner#inquiry", section: "Partner" }
  ];
  function initSearch() {
    var trigger = document.querySelector(".search-trigger");
    var overlay = document.querySelector(".search-overlay");
    if (!trigger || !overlay) return;
    var input = overlay.querySelector("input");
    var results = overlay.querySelector(".search-results");

    function render(query) {
      var q = query.trim().toLowerCase();
      var matches = q ? SEARCH_INDEX.filter(function (item) {
        return item.title.toLowerCase().indexOf(q) !== -1 || item.section.toLowerCase().indexOf(q) !== -1;
      }) : SEARCH_INDEX;
      results.innerHTML = "";
      if (!matches.length) {
        var empty = document.createElement("div");
        empty.className = "search-empty";
        empty.textContent = "No matches. Try \u201cshop\u201d, \u201cpartner\u201d, or \u201cjoin\u201d.";
        results.appendChild(empty);
        return;
      }
      matches.forEach(function (item) {
        var a = document.createElement("a");
        a.href = item.url;
        a.innerHTML = "<strong>" + item.title + "</strong><span>" + item.section + "</span>";
        results.appendChild(a);
      });
    }

    function open() {
      overlay.classList.add("is-open");
      render("");
      input.value = "";
      setTimeout(function () { input.focus(); }, 30);
    }
    function close() {
      overlay.classList.remove("is-open");
    }

    trigger.addEventListener("click", open);
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    input.addEventListener("input", function () { render(input.value); });
    document.addEventListener("keydown", function (e) {
      if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        open();
      } else if (e.key === "Escape" && overlay.classList.contains("is-open")) {
        close();
      }
    });
  }

  /* ---------------- Init ---------------- */
  document.addEventListener("DOMContentLoaded", function () {
    initTheme();
    initMenu();
    initHeaderScroll();
    initScrollProgress();
    initBackToTop();
    initFloatingContact();
    initImageLoad();
    initFaq();
    initPasswordToggles();
    initCopyButtons();
    initModals();
    initUtmTracking();
    initBuyButtons();
    initForms();
    initSearch();
  });
})();
